<template>
    <ul class="dd-m-menu__content">
        <!-- Caso seja o fim de um grupo de menu, use a classe dd-m-menu__item--bordered na última <li> -->
        
        <div class="footer-cols">
            <div class="footer-left" v-for="column in menuItems" >
                <li v-for="item in column" class="dd-m-menu__item">
                    <a class="dd-m-menu__link" :href="item.href" :target="item.target"  title="Home">
                        <i class="dd-m-icon" :class="item.icon"></i>
                        <span>{{item.title}}</span>
                        
                        
                    </a>
                </li>
            </div>
            
            <div class="footer-right" style="display: none;">
                <terms-and-conditions-item></terms-and-conditions-item>
                <privacy-policy-item></privacy-policy-item>
                <li class="dd-m-menu__item">
                    <a class="dd-m-menu__link" :href="'/sitemap'" :title="getTranslateString('Site Map')">
                        <i class="dd-m-icon icon-paper"></i>
                        <span>{{getTranslateString('Site Map')}}</span>
                    </a>
                </li>
                <li class="dd-m-menu__item">
                    <a class="dd-m-menu__link"
                    target="_blank"
                    href="https://www.avon.uk.com/contact-us"
                    title="Become a Reseller">
                        <i class="dd-m-icon icon-people"></i>
                        <span>{{getTranslateString('Contact us')}}</span>
                    </a>
                </li>
                
                <auth-logout></auth-logout>
            </div>
        </div>    
    </ul>
</template>
<script>
    
    import TermsAndConditionsItem from "../pages/terms-and-conditions/terms-and-conditions-item";
    import PrivacyPolicyItem from "../pages/privacy-policy/privacy-policy-item";
    import AuthLogout from "../auth/auth-logout";

    export default {
        name: 'content-menu',
        components: {AuthLogout, PrivacyPolicyItem, TermsAndConditionsItem},
        props: ['menuItems'],
        mounted() {
        
        
        },
        methods: {}
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/header/content-menu.vue